import { TypographyProps } from '@material-ui/core';
import { ElementType, CSSProperties } from 'react';

// ====================================
// Enums
export enum FsDirection {
  UP = 'UP',
  DOWN = 'DOWN',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export enum FsComponentSize {
  XS = 'XS',
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
}

export enum LoadingState {
  INITIAL = 'INITIAL',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export const LoadingStates: LoadingState[] = Object.values(LoadingState);

export enum Sentiment {
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
}

export const Sentiments: Sentiment[] = Object.values(Sentiment);

export enum TransactionType {
  EXPENDITURE = 'EXPENDITURE',
  INCOME = 'INCOME',
  TOP_EXPENDITURE = 'TOP_EXPENDITURE',
  TOP_INCOME = 'TOP_INCOME',
}

export enum ModalState {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAILS',
}

export enum AccountType {
  PERSONAL = 'PERSONAL',
  BUSINESS = 'BUSINESS',
}

export const AccountTypes: AccountType[] = Object.values(AccountType);

export enum BillingCycleOption {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export const BillingCycleOptions: BillingCycleOption[] = Object.values(
  BillingCycleOption
);

export enum BillingPlanOption {
  PAY_AS_YOU_GROW = 'PAY_AS_YOU_GROW',
  ENTERPRISE = 'ENTERPRISE',
}

export enum UserRole {
  ADMIN = 'ADMIN',
  LEADER = 'LEADER',
  DEV = 'DEV',
  ACCOUNTANT = 'ACCOUNTANT',
  USER = 'USER',
}

export const UserRoles: UserRole[] = Object.values(UserRole);

export enum UserBillingType {
  STANDARD = 'STANDARD',
  ENTERPRISE = 'ENTERPRISE',
  EXCLUDED = 'EXCLUDED',
}

export enum ReportStatus {
  READY = 'READY',
  IN_PROGRESS = 'IN_PROGRESS',
  BROKEN = 'BROKEN',
}

export const ReportStatuses: ReportStatus[] = Object.values(ReportStatus);

export enum InvitationStatus {
  REJECTED = 'REJECTED',
  SENT = 'SENT',
  OPENED = 'OPENED',
}

export const InvitationStatuses: InvitationStatus[] = Object.values(
  InvitationStatus
);

export enum TeammateStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  INACTIVE = 'INACTIVE',
}

export const TeammateStatuses: TeammateStatus[] = Object.values(TeammateStatus);

export enum NotificationType {
  REPORTS = 'REPORTS',
  BANKS = 'BANKS',
  OTHERS = 'OTHERS',
}

export const NotificationTypes: NotificationType[] = Object.values(
  NotificationType
);

export enum EventType {
  NEW_DEBT = 'NEW_DEBT',
  DEBT_MANAGEMENT = 'DEBT_MANAGEMENT',
  POSSIBLE_LOSS_OF_INCOME = 'POSSIBLE_LOSS_OF_INCOME',
  OUT_OF_WORK_BENEFITS = 'OUT_OF_WORK_BENEFITS',
  NEW_EMPLOYER = 'NEW_EMPLOYER',
  NEGATIVE_BALANCE_RATIO = 'NEGATIVE_BALANCE_RATIO',
  SOME_OTHER_TYPE = 'SOME_OTHER_TYPE',
}

export const EventTypes: EventType[] = Object.values(EventType);

// ====================================
// Interfaces

export interface UpgradeRoutingParams {
  cycle: BillingCycleOption;
  plan: BillingPlanOption;
  id: string;
}

export interface ResetPasswordParams {
  id: string;
}

export interface LoginParams {
  id: string;
}

export interface TypographyAllProps extends TypographyProps {
  component?: ElementType;
  style?: CSSProperties;
}
